import { jsx } from '@emotion/core';
import { facepaintMediaQueries } from '../shared';
import { GRID } from '../../constants';
var styles = facepaintMediaQueries({
  display: 'block',
  marginTop: [GRID.small, GRID.small, GRID.large],
  marginBottom: GRID.xsmall,
  boxSizing: 'border-box',
  '> *': {
    marginBottom: [GRID.xsmall, 0]
  }
});
export var OneColumn = function OneColumn(_a) {
  var children = _a.children;
  return jsx("div", {
    css: styles
  }, children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Grid/OneColumn.js
// module id = 830
// module chunks = 0